Vendd.Scripts.load(function () {

    $('.x-control[data-control="pager"][data-type="info"]').each(function (i, item) {
        var $wrapper = $(this);

        var isPagerAjax = $wrapper.data('ajax');

        if (isPagerAjax) {
            var connectedList = $wrapper.data('list');
            if (connectedList === undefined)
                throw 'Connected list not declared for pager ' + $wrapper.attr('id');

            var $connectedList = $('.x-control[data-control="list"][data-list="' + connectedList + '"]').first();

            $connectedList.get(0).bind('dataload', function (control, response) {
                var currentConfig = $connectedList.get(0).getConfiguration(); // chriss TODO

                var pageNumber = currentConfig.LoaderData.PageNumber;
                var pageSize = currentConfig.LoaderData.PageSize;
                var pageCount = Math.ceil(response.Data.ItemsCount / pageSize);

                var itemStart = ((pageNumber * pageSize) - pageSize) + 1;
                var itemStop = (itemStart - 1) + response.Data.Items.length;
                var itemCount = response.Data.ItemsCount;

                $wrapper.find('*[data-pager-itemstart]').html(itemStart);
                $wrapper.find('*[data-pager-itemstop]').html(itemStop);
                $wrapper.find('*[data-pager-itemcount]').html(itemCount);

                $wrapper.find('*[data-pager-pagenumber]').html(pageNumber);
                $wrapper.find('*[data-pager-pagesize]').html(pageSize);
                $wrapper.find('*[data-pager-pagecount]').html(pageCount);
            });
        }
    });

});